import { render, staticRenderFns } from "./BillsTab.vue?vue&type=template&id=c50cb39c&scoped=true"
import script from "./BillsTab.vue?vue&type=script&lang=js"
export * from "./BillsTab.vue?vue&type=script&lang=js"
import style0 from "./BillsTab.vue?vue&type=style&index=0&id=c50cb39c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c50cb39c",
  null
  
)

export default component.exports